import { useStatistics } from './StatiscticsContext';
import SalesIcon from '@/assets/icons/V3/statistics/SalesIcon.svg?react';
import AdjustmentIcon from '@/assets/icons/V3/statistics/AdjustmentIcon.svg?react';
import DisconnectIcon from '@/assets/icons/V3/statistics/DisconnectIcon.svg?react';
import ExcelNotice from './ExcelNotice';
import { useRef, useEffect } from 'react';
import { autoComma, formatKSTtoMonthDay } from '@/utils/parser';
import { useAppSelector } from '@/redux/store';
import { useNavigate } from 'react-router-dom';
import ExcelAgreementCTA from './ExcelAgreementCTA';
import { ROUTES } from '@/routes';
import {
  STATISTICS_DAILY_ROOT_CLASS_NAME,
  STATISTICS_DAILY_SALES_SECTION_CLASS_NAME,
} from '../statistics-page-layout';

const StatisticsDaily = () => {
  const user = useAppSelector((state) => state.user);
  const navigate = useNavigate();
  const { selectedDate, isDailyLoading, dailyMarketList, dailySalesInfo, dailySettleInfo } =
    useStatistics();

  const marketListRef = useRef<HTMLDivElement | null>(null);

  // 날짜(selectedDate)가 바뀔 때마다 스크롤 최상단으로
  useEffect(() => {
    if (marketListRef.current) {
      marketListRef.current.scrollTop = 0;
    }
  }, [selectedDate]);

  const navigateToRegisterMarket = () => {
    navigate(ROUTES.market);
  };

  return (
    <div className={STATISTICS_DAILY_ROOT_CLASS_NAME}>
      <div className={STATISTICS_DAILY_SALES_SECTION_CLASS_NAME}>
        {/* 오버레이 스피너 */}
        {isDailyLoading && <OverlaySpinner />}
        <div className=" flex flex-col gap-3 border-b border-gr-200 pb-[16px]">
          {/* 상단 날짜 네비 */}
          <div className="flex text-gr-900 Body1S16">
            <span className="">{formatKSTtoMonthDay(selectedDate)} 매출</span>
          </div>

          {/* 매출/정산 요약 */}
          <div className="grid grid-cols-2 ">
            <div className="flex items-center gap-5 ">
              <div className="flex items-center gap-2">
                <SalesIcon />
                <span className="text-gr-800 Body2M16">매출</span>
              </div>
              <div className="flex items-center text-gr-800 Body1S16">
                <span>{autoComma(dailySalesInfo.TotalSalesAmount)}원</span>
                <span className="ml-1">({autoComma(dailySalesInfo.TotalSalesCount)}건)</span>
              </div>
            </div>
            <div className="flex items-center gap-5 ">
              <div className="flex items-center gap-2">
                <AdjustmentIcon />
                <span className="text-gr-800 Body2M16">정산</span>
              </div>
              <div className="flex items-center text-gr-800 Body1S16">
                <span>{autoComma(dailySettleInfo.TotalSettleAmount)}원</span>
              </div>
            </div>
          </div>
        </div>

        {/* 스토어(마켓)별 리스트 */}
        <div
          ref={marketListRef}
          className="scrollbar h-full w-full flex-1 flex-col space-y-[16px] overflow-y-auto py-[16px]"
        >
          {dailyMarketList.length === 0 ? (
            <div className="py-8 text-center text-gr-400" />
          ) : (
            dailyMarketList.map((item, idx) => (
              <div key={idx} className="flex w-full flex-col items-start gap-2 ">
                <div className="flex items-center gap-[6px]">
                  <img
                    src={item.MarketIconUrl}
                    alt="마켓 아이콘"
                    className="h-5 w-5 rounded-full"
                  />
                  <span
                    className={`text-gr-800 Body5M14 ${item.IsConnectedOff ? 'opacity-40' : ''}`}
                  >
                    {item.StoreName}
                  </span>
                  {item.IsConnectedOff && (
                    <span
                      onClick={() => navigateToRegisterMarket()}
                      className="ml-2 flex cursor-pointer  items-center gap-1 rounded bg-red-100 px-2 py-1 text-xs text-red-400"
                    >
                      <DisconnectIcon />
                      다시 연결하기
                    </span>
                  )}
                </div>
                <div className="grid w-full grid-cols-2 rounded-[10px] bg-gr-50 p-[10px]">
                  <div className="flex gap-[20px]  text-gr-600 Body5M14">
                    <span className="text-gr-600 Body5M14">매출</span>
                    <div>
                      <span className="text-gr-700">{autoComma(item.SalesAmount)}원</span>
                      <span className="ml-1 text-gr-700">({autoComma(item.SalesCount)}건)</span>
                    </div>
                  </div>
                  <div className="flex gap-[20px]  text-gr-600 Body5M14">
                    <span className="text-gr-600 Body5M14">정산</span>
                    <div>
                      <span className="text-gr-700">{autoComma(item.SettleAmount)}원</span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* 하단 엑셀 안내 */}
        {/* 하단 안내 - 동의여부에 따라 분기 */}
        {user.EmailAddreess ? <ExcelNotice /> : <ExcelAgreementCTA />}
      </div>
    </div>
  );
};

export default StatisticsDaily;

const OverlaySpinner = () => (
  <div className="absolute inset-0 z-20 flex items-center justify-center bg-white/40 backdrop-blur-sm">
    <svg className="h-10 w-10 animate-spin text-violet-500" viewBox="0 0 24 24">
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
        fill="none"
      />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
    </svg>
    <span className="ml-4 text-lg font-semibold text-violet-700">로딩 중...</span>
  </div>
);
